import { render } from "./UploadException.vue?vue&type=template&id=a24b7948&ts=true"
import script from "./UploadException.vue?vue&type=script&lang=ts"
export * from "./UploadException.vue?vue&type=script&lang=ts"

import "./UploadException.vue?vue&type=style&index=0&id=a24b7948&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__